import { useState } from "react";
import { Camera } from "lucide-react";
import { BACKEND } from "@/lib/api";
import { Loading, Table, Title, fmtDT, todayTR, useData } from "@/ops/ui";

const LOC = { ok: "Başarılı", outside: "Mesafe dışı", no_location: "Konum yok", no_reference: "Referans yok" };
const CLS = { on_time: "text-emerald-700", late: "text-orange-700", missing: "text-red-700", photo_missing: "text-red-700", gps_failed: "text-red-700", pending: "text-zinc-500" };

function Rows({ pid, day }) {
  const [rep] = useData("/ops/admin/reports/patrol", { project_id: pid, day });
  if (!rep) return <Loading />;
  const rows = rep.rounds.filter((r) => r.photo_required);
  return (
    <Table head={["Plan saati", "Güzergâh", "Nokta", "Durum", "Okutma", "Personel", "GPS", "Fotoğraf"]} testid="photo-patrol-table">
      {rows.map((r) => (
        <tr key={`${r.patrol}-${r.checkpoint}-${r.planned}`}><td className="px-3 py-2 font-semibold">{r.planned}</td><td className="px-3 py-2">{r.patrol}</td><td className="px-3 py-2">{r.checkpoint}</td>
          <td className={`px-3 py-2 text-xs font-semibold ${CLS[r.status]}`}>{r.status_label}</td><td className="whitespace-nowrap px-3 py-2 text-xs">{r.scan ? fmtDT(r.scan.at) : "-"}</td>
          <td className="px-3 py-2">{r.scan?.employee_name || "-"}</td><td className="px-3 py-2 text-xs">{r.scan ? `${LOC[r.scan.location_status]}${r.scan.distance_m != null ? ` · ${Math.round(r.scan.distance_m)} m` : ""}` : "-"}</td>
          <td className="px-3 py-2">{r.scan?.has_photo ? <a href={`${BACKEND}/api/ops/admin/scans/${r.scan.id}/photo`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs font-semibold text-blue-700"><Camera className="h-3 w-3" /> Görüntüle</a> : <span className="text-xs text-zinc-400">Yok</span>}</td></tr>
      ))}
      {!rows.length && <tr><td colSpan={8} className="p-6 text-center text-zinc-500">Bu gün için fotoğraflı devriye planı yok. Planı proje → Devriye Güzergâhları bölümünde "Fotoğraf zorunlu" seçerek oluşturun.</td></tr>}
    </Table>
  );
}

export default function PhotoPatrol() {
  const [projects] = useData("/ops/admin/projects");
  const [pid, setPid] = useState("");
  const [day, setDay] = useState(todayTR());
  return (
    <div>
      <Title title="Fotoğraflı Devriye Takibi" desc="Fotoğraf zorunlu planlarda fotoğrafsız veya GPS doğrulaması başarısız okutma tamamlanmış sayılmaz." />
      <div className="mb-4 flex flex-wrap gap-3">
        <select value={pid} onChange={(e) => setPid(e.target.value)} className="field-input max-w-sm" data-testid="photo-project"><option value="">Proje seçin...</option>{(projects || []).map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select>
        <input type="date" value={day} onChange={(e) => setDay(e.target.value)} className="field-input max-w-[200px]" data-testid="photo-date" />
      </div>
      {pid ? <Rows pid={pid} day={day} /> : <p className="text-sm text-zinc-500">Proje seçin.</p>}
    </div>
  );
}
